const isLoggingEnabled = !!process.env.TEST_API;

export default {
  info(message, ...args) {
    if (isLoggingEnabled) {
      return console.info(message, ...args);
    }
  },
  warn(message, ...args) {
    if (isLoggingEnabled) {
      return console.warn(message, ...args);
    }
  },
  error(message, ...args) {
    if (isLoggingEnabled) {
      return console.error(message, ...args);
    }
  },
  debug(message, ...args) {
    if (isLoggingEnabled) {
      return console.debug(message, ...args);
    }
  },
};
